import { theme } from 'antd'
import { ThemeCommon } from './theme.common'
import { ThemeType } from './theme.config'

export const ThemeAdmin: ThemeType = {
  algorithm: theme.defaultAlgorithm,
  token: {
    ...ThemeCommon.token,
  },
  components: {
    Layout: {
      headerBg: 'white',
      headerPadding: 0,
    },
    Collapse: {
      contentBg: 'white',
      contentPadding: 4,
      headerBg: 'white',
      headerPadding: 4,
      colorBorder: '#e5e7eb',
    },
  },
}
